import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classes"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useState } from 'react';
import Icon from '../../general/Icon';
import Input from '../Input';
import { createUseStyles } from '../../../utils/styles';
import { useClasses } from '../../../utils/overrides';
import styles from './styles';
var useStyles = createUseStyles(styles, 'Password');
var Password = function Password(_ref) {
  var classesProp = _ref.classes,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  var _useState = useState('password'),
    _useState2 = _slicedToArray(_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];
  var icon = /*#__PURE__*/React.createElement(Icon, {
    onClick: function onClick() {
      return setType(type === 'password' ? 'text' : 'password');
    },
    className: classes.visibility,
    name: type === 'password' ? 'visibilityOn' : 'visibilityOff'
  });
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    classes: classesProp,
    type: type,
    postComponent: icon
  }));
};
process.env.NODE_ENV !== "production" ? Password.propTypes = _objectSpread({}, Input.propTypes) : void 0;
export default /*#__PURE__*/memo(Password);